import { ContactFormRequest } from '@/models/Content';
import { NavigationItem, NavigationItemResponse } from '@/models/Navigation';
import axios, { AxiosResponse } from 'axios';

export default class ContentService {

    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId)
            this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/content`;
    }

    public async getChildren(id: string = ''): Promise<NavigationItem[]> {
        try {
            const res: AxiosResponse<NavigationItemResponse> = await axios.get(`${this.endpoint}/children/${id}`);
            return res.data.children;
        } catch (e) {
            console.log(e);
        }
    }

    public async getChildrenWithParent(id: string = '__root__'): Promise<NavigationItemResponse> {
        if (id === '__root__') id = '';
        try {
            const res: AxiosResponse<NavigationItemResponse> = await axios.get(`${this.endpoint}/children/${id}`);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async getCustomContent(forceexpand: boolean = false): Promise<NavigationItemResponse> {
        try {
            const res: AxiosResponse<NavigationItemResponse> = await axios.get(`${this.endpoint}/custom/${forceexpand}`);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async sendContactRequest(payload: ContactFormRequest): Promise<boolean> {
        const data = new FormData();

        this.addFormData(data, 'contactrequest', JSON.stringify(payload));
        payload.fields.filter(field => field.type === 'upload').forEach(field => {
            field.files?.forEach(file => {
                this.addFormData(data, 'uploadFile', file.file, file.id);
            });
        });

        try {
            await axios({
                method: 'POST',
                headers: {
                    'token': (window as any).CbxPageToken,
                },
                url: `${this.endpoint}/contactrequest`,
                data,
            });          
            return true;
        } catch (e) {
            return false;
        }
    }

    public async sendNewCustomerRequest(payload: any): Promise<any> {
        try {
            return await axios.post(`${this.endpoint}/newcustomerrequest`, payload, {
                headers: {
                    'token': (window as any).CbxPageToken,
                },
            });
        } catch (e) {
            return false;
        }
    }

    private addFormData(formdata: FormData, key: string, value: any, filename: any = null) {
        if (filename) formdata.append(key, value as any, filename);
        else formdata.append(key, value as any);
    }
}
